export default "__VITE_ASSET__sEQsCzXX__"